import { useState } from "react";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { FormDynamic } from "../FormDynamic";
import { QuizDynamicModal } from "../QuizDynamicModal";
import { QuizzesDynamic } from "../QuizzesDynamic";
import { Store } from "../Store";
import { Benefits } from "../Benefits";
import { Search } from "../Seach";
import { Fallback } from "../FallBack";
import { ValidTermAccepted } from "../ValidTermAccepted";

import { useInduction } from "../../hooks/useInduction";
import { Container } from "./styles";


export default function Home() {
    const { displayStore, displayBenefits, displayForm, displayQuizzes, displaySearch, displayValidTermAccepted, isActiveLoader, showHeaderFooter } = useInduction();



    const [isNewQuizDynamicModalOpen, setIsNewQuizDynamicModalOpen] = useState(false);
    const [quizId, setQuizId] = useState(0);

    function handleOpenNewQuizDynamicModal(value: number) {

        setIsNewQuizDynamicModalOpen(true);
        setQuizId(value);
    }

    function handleCloseNewQuizDynamicModal() {
        setIsNewQuizDynamicModalOpen(false);
        setQuizId(0);
    }

    return (
        <Container>
            {showHeaderFooter && <Header />}
            {displayStore && <Store />}
            {displayBenefits && <Benefits />}
            {displaySearch && <Search />}
            {displayValidTermAccepted && <ValidTermAccepted />}
            {displayForm && <FormDynamic />}
            {displayQuizzes && <QuizzesDynamic onOpenNewQuizDynamicModal={handleOpenNewQuizDynamicModal} />}
            {displayQuizzes && quizId > 0 && <QuizDynamicModal
                isOpen={isNewQuizDynamicModalOpen}
                onRequestClose={handleCloseNewQuizDynamicModal}
                quizId={quizId}
            />}
            <Fallback isActive={isActiveLoader} />
            {showHeaderFooter && <Footer />}
        </Container>
    );
}